import { IUser } from "../@core/models/model";

export const SIDEBAR_IDS = {
    MAIN: 'MAIN_SIDEBAR',
    SETTINGS: 'SETTINGS_SIDEBAR',
    GENERAL_AGENT: 'GENERAL_AGENT_SIDEBAR',
}


export const NO_OF_EMPLOYEES = ['1-10', '11-50', '51-100', '101-500', '501-1000', '1000+'];
export const WORKSPACE_PREFIX = 'inncircles.ai/';

export function retrieveDisplayNameForUser(user: IUser) {
    if (!user) {
        return '';
    }
    return user.firstName ? (user.lastName ? user.firstName + ' ' + user.lastName : user.firstName) : (user.lastName ? user.lastName : (user.email ? user.email : ''));
}

export const validateEmail = (email: string) => {
    const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
    return emailRegex.test(email);
};

const MIME_TO_EXTENSION: Record<string, string> = {
    'application/pdf': 'pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'application/vnd.ms-powerpoint': 'ppt',
    'text/plain': 'txt',
    'text/csv': 'csv',
    'application/zip': 'zip',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/webp': 'webp',
    'image/svg+xml': 'svg',
};

export function getExtensionFromMimeType(mimeType: string, fallback = 'pdf'): string {
    return MIME_TO_EXTENSION[mimeType] ?? fallback;
}

export function downloadDocument(uint8Array: Uint8Array, fileName: string, mimeType?: string) {
    const blob: Blob = new Blob([new Uint8Array(uint8Array)], {
        type: mimeType ? mimeType : 'application/pdf'
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    const ext = mimeType ? getExtensionFromMimeType(mimeType) : 'pdf';
    link.download = `${fileName}.${ext}`;
    document.body.append(link);
    link.click();
    link.remove();
}

export function base64ToBlob(base64String: string, mimeType: string): Blob {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
}

export function toFixedNumber(num: number, decimals: number): number {
    return Number(num.toFixed(decimals))
}

export function getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

export const formatBufferSize = (bufferSize: number) => {
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    let index = 0;
    let size = bufferSize;

    while (size >= 1024 && index < units.length - 1) {
        size /= 1024;
        index++;
    }

    return `${size.toFixed(2)} ${units[index]}`;
}

export const escapeRegExp = (str: string) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
